import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectOption } from '../../../types/purchases/CreditNoteLookup';

interface CreditNoteLookupState {
  filteredDocuments: SelectOption[];  // Lista de CCF filtrados
  productOptions: SelectOption[];     // Productos de un CCF seleccionado
}

const initialState: CreditNoteLookupState = {
  filteredDocuments: [],
  productOptions: [],
};

const creditNoteLookupSlice = createSlice({
  name: 'creditNoteLookup',
  initialState,
  reducers: {
    setFilteredDocuments(state, action: PayloadAction<SelectOption[]>) {
      state.filteredDocuments = action.payload;
    },
    clearFilteredDocuments(state) {
      state.filteredDocuments = [];
    },
    setProductOptions(state, action: PayloadAction<SelectOption[]>) {
      state.productOptions = action.payload;
    },
    clearProductOptions(state) {
      state.productOptions = [];
    },
  },
});

export const {
  setFilteredDocuments,
  clearFilteredDocuments,
  setProductOptions,
  clearProductOptions,
} = creditNoteLookupSlice.actions;

export default creditNoteLookupSlice.reducer;
